/**
 * tdesign v0.46.3
 * (c) 2022 tdesign
 * @license MIT
 */

var props = {
  allowInput: Boolean,
  clearable: Boolean,
  disabled: {
    type: [Boolean, Array],
    "default": false
  },
  disableTime: {
    type: Function
  },
  format: {
    type: String,
    "default": "HH:mm:ss"
  },
  hideDisabledTime: {
    type: Boolean,
    "default": true
  },
  placeholder: {
    type: [String, Array],
    "default": void 0
  },
  popupProps: {
    type: Object
  },
  rangeInputProps: {
    type: Object
  },
  size: {
    type: String,
    "default": "medium",
    validator: function validator(val) {
      if (!val) return true;
      return ["small", "medium", "large"].includes(val);
    }
  },
  steps: {
    type: Array,
    "default": function _default() {
      return [1, 1, 1];
    }
  },
  value: {
    type: Array
  },
  defaultValue: {
    type: Array
  },
  onBlur: Function,
  onChange: Function,
  onFocus: Function,
  onInput: Function
};

export { props as default };
//# sourceMappingURL=time-range-picker-props.js.map
